// @flow
import _ from 'lodash'
import React, { Component } from 'react'
import AutoSizeTextArea from '../../AutoSizeTextArea'
import styled, { type StyledComponent } from 'styled-components'

const inputStyles = `
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  color: #000;
  padding: 6px 10px 6px 10px;
  min-height: 33px;
  line-height: 16px;
  width: 100%;
`

const StyledInput: StyledComponent<Object, any, any> = styled.input`
  ${inputStyles};
`

const StyledAutoSizeTextArea: typeof AutoSizeTextArea = styled(AutoSizeTextArea)`
  ${inputStyles} padding-top: 9px;
`

type Props = {|
  value: string,
  multiline?: boolean,
  inputProps?: Object,
  extraStyles?: Object,
  onChange: (string) => void,
  disabled?: boolean,
  noNewlines?: boolean
|}

export default class LineInput extends Component<Props> {
  render() {
    const value = this.props.value || ''

    if (this.props.multiline) {
      return (
        <StyledAutoSizeTextArea
          style={this.styles({ resize: 'none' })}
          value={value}
          onChange={(e) => this.changed(e)}
          disabled={this.props.disabled}
          {...this.props.inputProps}
        />
      )
    } else {
      return (
        <StyledInput
          type="text"
          style={this.styles({})}
          value={value}
          onChange={(e) => this.changed(e)}
          disabled={this.props.disabled}
          {...this.props.inputProps}
        />
      )
    }
  }

  changed(e: any) {
    let value = e.target.value

    if (this.props.noNewlines) value = value.replace('\n', '').replace('\r', '')

    this.props.onChange(value)
  }

  styles(extraStyles: Object): Object {
    return _.extend({}, extraStyles, this.props.extraStyles)
  }
}
